import scheduleRows from '../actions/actionCreators/scheduleRows';
import { orchestrator } from 'satcheljs';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import scheduleItems from '../actions/scheduleItems';
import scheduleConversations from '../actions/scheduleConversations';
import { getStore } from 'owa-mail-list-store';

orchestrator(scheduleRows, actionMessage => {
    const { rowKeys, actionSource, scheduleReturnTime, tableViewId } = actionMessage;
    const tableView = getStore().tableViews.get(tableViewId);
    switch (tableView.tableQuery.listViewType) {
        case ReactListViewType.Conversation:
            scheduleConversations(rowKeys, tableView, actionSource, scheduleReturnTime);
            return;

        case ReactListViewType.Message:
            scheduleItems(rowKeys, tableView, actionSource, scheduleReturnTime);
            return;

        default:
            throw new Error('scheduleRows: Invalid listView type');
    }
});
